import { render, staticRenderFns } from "./PathNavigation.vue?vue&type=template&id=53eb857c&scoped=true&"
import script from "./PathNavigation.vue?vue&type=script&lang=js&"
export * from "./PathNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PathNavigation.vue?vue&type=style&index=0&id=53eb857c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53eb857c",
  null
  
)

export default component.exports